import React, { Component } from 'react';

import Map from './Map'

class Contact extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <div id="Contact">
        
        <div className="contactField">
          <h2>Contact</h2>
          <p>Phone: <a href="tel:+447740262054">077 402 620 54</a></p>
          <p>Email: <a href="mailto:atcgardening@gmail.com">atcgardening@gmail.com</a></p>
          <p>Facebook: <a href="https://www.facebook.com/ATCLandscaping" target="_blank"><i class="fab fa-facebook-square fa-lg"></i></a></p>
          <h2>Address</h2>
          <p>20 Polmeur Road</p>
          <p>Kelloholm</p>
          <p>DG4 6SG</p>
          <p>United Kingdom</p>
        </div>
        <div className="contactField">
          <h2>Business hours</h2>
          <table>
            <tbody>
              <tr>
                <th style={{padding: '0 40px 0 0'}}>Monday</th>
                <td>
                  <span>8:00 AM – 6:00 PM</span>
                </td>
              </tr>
              <tr  style={{height: '3px'}}/>
              <tr>
                <th style={{padding: '0 40px 0 0'}}>Tuesday</th>
                <td>
                  <span>8:00 AM – 6:00 PM</span>
                </td>
              </tr>
              <tr  style={{height: '3px'}}/>
              <tr>
                <th style={{padding: '0 40px 0 0'}}>Wednesday</th>
                <td>
                  <span>8:00 AM – 6:00 PM</span>
                </td>
              </tr>
              <tr  style={{height: '3px'}}/>
              <tr>
                <th style={{padding: '0 40px 0 0'}}>Thursday</th>
                <td>
                  <span>8:00 AM – 6:00 PM</span>
                </td>
              </tr>
              <tr  style={{height: '3px'}}/>
              <tr>
                <th style={{padding: '0 40px 0 0'}}>Friday</th>
                <td>
                  <span>8:00 AM – 6:00 PM</span>
                </td>
              </tr>
              <tr  style={{height: '3px'}}/>
              <tr>
                <th style={{padding: '0 40px 0 0'}}>Saturday</th>
                <td>
                  <span>8:00 AM – 6:00 PM</span>
                </td>
              </tr>
              <tr  style={{height: '3px'}}/>
              <tr>
                <th style={{padding: '0 40px 0 0'}}>Sunday</th>
                <td>
                  <span>CLOSED</span>
                </td>
              </tr>
              <tr  style={{height: '3px'}}/>
            </tbody>
          </table>
        </div>
        <Map />
      </div>
    )
  }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.jsx